module.exports = __webpack_public_path__ + "img/background.0ba81bfb.jpg";